module.exports = __webpack_public_path__ + "img/settings_edit_layout.fb0014a8.png";